module.exports = __webpack_public_path__ + "assets\\img\\icons\\safari-pinned-tab.svg?963ca284ae4e8ba3f489";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/safari-pinned-tab.svg
// module id = 153
// module chunks = 0